import * as React from 'react';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
const IconSparkle = (props)=>/*#__PURE__*/ React.createElement("svg", _object_spread({
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em"
    }, props), /*#__PURE__*/ React.createElement("path", {
        d: "M2.49155 15.4471L2.66873 14.7184L2.49155 15.4471L2.81061 15.5247C5.42574 16.1605 7.47601 18.1881 8.14062 20.7958L8.24659 21.2116C8.5338 22.3384 10.1203 22.3773 10.4624 21.2659L10.7137 20.4493C11.4578 18.0314 13.4051 16.1739 15.8556 15.5443L16.2469 15.4438C17.3515 15.16 17.4153 13.6151 16.3377 13.2412L15.2858 12.8763C13.1578 12.1381 11.4919 10.4558 10.7747 8.32091L10.4531 7.36369L9.74218 7.60253L10.4531 7.36369C10.0918 6.2882 8.55688 6.32868 8.2528 7.42175L8.10345 7.95859C7.45206 10.3001 5.67399 12.1616 3.36455 12.9197L2.40446 13.2348C1.30388 13.5961 1.36601 15.1735 2.49155 15.4471Z",
        stroke: "black",
        strokeWidth: 1.5,
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M19.2165 2.2187L18.5056 2.45754L19.2165 2.2187C18.9215 1.34062 17.6683 1.37366 17.4201 2.2661L17.3494 2.52018C17.0765 3.50123 16.3315 4.28116 15.3638 4.5988L14.9094 4.74796C14.0109 5.04293 14.0616 6.3308 14.9805 6.5542L14.9805 6.5542L15.1316 6.59092C16.2273 6.8573 17.0863 7.70686 17.3648 8.79941L17.4149 8.99619C17.6494 9.91623 18.9447 9.94795 19.224 9.04054L19.3429 8.65407C19.6547 7.64104 20.4706 6.86273 21.4973 6.59894L21.6825 6.55136C22.5844 6.31965 22.6364 5.0583 21.7567 4.75311L21.2588 4.58039C20.3672 4.27109 19.6692 3.56623 19.3687 2.67175L19.2165 2.2187ZM15.5643 5.20956L15.5978 5.31139L15.5643 5.20956Z",
        stroke: "black",
        strokeWidth: 1.5,
        strokeLinecap: "square",
        strokeLinejoin: "round"
    }));

export { IconSparkle };
